// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"edd31b4f","665":"e8c26ad7","704":"50f480c1","898":"6fa5f34e","963":"441fa6e6"}[chunkId] + ".chunk.css";
};